
import CreateWindow from "./fullscreenModal";
import { html, render } from "lit-html";
import "./orientationAlert.css"
import img from "./screenorientation.png"
import { pickText } from "../textcontents";

const icon = () => html`<svg xmlns="http://www.w3.org/2000/svg"  width="120" height="120" viewBox="0 0 48 48">
    <path d="M0 0h48v48h-48z" fill="none"/>
    <path d="M32.97 5.03c6.53 3.1 11.22 9.45 11.93 16.97h3c-1.02-12.32-11.32-22-23.9-22-.45 0-.88.04-1.33.07l7.63 7.63 2.67-2.67zm-12.51-1.54c-1.17-1.17-3.07-1.17-4.24 0l-12.73 12.73c-1.17 1.17-1.17 3.07 0 4.24l24.04 24.04c1.17 1.17 3.07 1.17 4.24 0l12.73-12.73c1.17-1.17 1.17-3.07 0-4.24l-24.04-24.04zm9.2 38.89l-24.05-24.04 12.73-12.73 24.04 24.04-12.72 12.73zm-14.63.59c-6.53-3.1-11.22-9.45-11.93-16.97h-3c1.02 12.32 11.32 22 23.9 22 .45 0 .88-.04 1.33-.07l-7.63-7.63-2.67 2.67z"/>
<script xmlns=""/></svg>`

const Orientation = function () {
  const markup = html`
    <div
      class="orientation-container"
      
    >
   ${icon()}
    <p>${pickText("mobileOrientation", "1")}</p>
    </div>
  `;
 // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
 const puzzleWindow = CreateWindow({orientationAlert: true})
  render(markup, puzzleWindow.element);
  return puzzleWindow.exit
};

export default Orientation;
